module.exports = __webpack_public_path__ + "img/banner-img.f7cff079.png";